import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Flex from '../Flex';
import { CardTitle } from './CardTitle';
import { CardBody } from './CardBody';
import { CardHeader } from './CardHeader';

/**
 * @param { React.HTMLAttributes<HTMLDivElement> & {
 *   children?: React.ReactNode;
 * }} props
 */
export default function Card({ className = '', children = null, ...rest }) {
  return (
    <Flex
      direction="column"
      gap={16}
      className={cn(styles.card, className)}
      {...rest}
    >
      {children}
    </Flex>
  );
}

Card.Title = CardTitle;
Card.Body = CardBody;
Card.Header = CardHeader;
